import axios from "axios";

export const fetchStripeAccountUrl = async (token) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/stripe/login`,
    {
      headers: {
        Authorization: `Bearer ${token}`, // JWT from login
      },
    }
  );
  return data;
};
